import { combineReducers } from 'redux';
import index from '../screens/Index/reducers/';
import passwordBegin from '../screens/PasswordBegin/reducers/';
import companySelection from '../screens/CompanySelection/reducers/';
import identifyActivation from '../screens/IdentifyActivation/reducers/';
import identifyRecovery from '../screens/IdentifyRecovery/reducers/';
import passwordReset from '../screens/PasswordReset/reducers/';

export default combineReducers({
  index,
  passwordBegin,
  companySelection,
  identifyActivation,
  identifyRecovery,
  passwordReset,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Login/reducers/index.js
 **/